import * as p from "../../common/hintParts";
import { AllHintStepData, HintSiteConfig } from "../../common/types";

const stepData1 = p.keywordStep("パネル", "ぱねる")("五十音クイズバトル", [
  p.foldable("何をすればいいかわからない", [
    p.text(
      "1st Battleの封筒に入っている「クイズシート」を見て、ためしに1つクイズに答えてみましょう。"
    ),
  ]),

  p.foldable("クイズに答えたが何をすればいいかわからない", [
    p.text(
      "このクイズの目標は問15「わたしの好きな食べ物は何？」に解答することです。"
    ),
    p.text(
      "1つクイズに答えるたびに、ウィンは相子先生の好きな食べ物の情報を思い出すようです。"
    ),
    p.text("とにかくたくさんクイズに正解して情報を集めましょう。"),
  ]),

  p.foldable(
    "クイズの答えがわからない（問題番号を押すとすぐに答えが表示されます）",
    [
      p.foldable("問1", [p.text("『みねらる』と答えると正解になります。")]),

      p.foldable("問2", [p.text("『くれよん』と答えると正解になります。")]),

      p.foldable("問3", [p.text("『ゆうやけ』と答えると正解になります。")]),

      p.foldable("問4", [p.text("『めろす』と答えると正解になります。")]),

      p.foldable("問5", [p.text("『たぬき』と答えると正解になります。")]),

      p.foldable("問6", [p.text("『ひなまつり』と答えると正解になります。")]),

      p.foldable("問7", [p.text("『あいこ』と答えると正解になります。")]),

      p.foldable("問8", [p.text("『たんか』と答えると正解になります。")]),

      p.foldable("問9", [p.text("『おきなわ』と答えると正解になります。")]),

      p.foldable("問10", [p.text("『ひきわけ』と答えると正解になります。")]),

      p.foldable("問11", [p.text("『くも』と答えると正解になります。")]),

      p.foldable("問12", [p.text("『もくせい』と答えると正解になります。")]),

      p.foldable("問13", [p.text("『はちまき』と答えると正解になります。")]),

      p.foldable("問14", [p.text("『いし』と答えると正解になります。")]),

      p.foldable("問15", [
        p.text(
          "この問題はクイズが始まった時点では解けないようです。先に他の問題に挑戦してみましょう。"
        ),
      ]),
    ]
  ),

  p.text(" "),
  p.text(" "),
  p.foldable("すべての勝負に勝利した人はこちら", [
    p.text(
      "ここから先は重大なネタバレが含まれます。\nすべての勝負に勝利していない方は絶対に見ないでください。"
    ),
    p.foldable("ウィンが勝利した先のヒントを見る", [
      p.text("ここから先は、ロゼを勝たせる方法を探している方向けの内容です。"),
      p.text(
        "すべての勝負でロゼが勝利する方法を探している場合は、第一勝負『五十音クイズ』から順番に攻略することを強くオススメします。"
      ),
      p.text(
        "また、「？」の封筒を開いていない方は、封筒を開いて中身を確認してから考えてみましょう。"
      ),
      p.foldable("ロゼを勝たせる方法のヒントが見たい", [
        p.text(
          "ロゼを勝たせる方法のヒントがほしい方は各勝負のヒントキーワードの先頭に「ロゼ」をつけて入力してください。"
        ),
      ]),

      p.foldable(
        "ロゼを勝たせることはできたがメッセージが出てきて先に進めない",
        [
          p.text(
            "ロゼが勝ちそうになると「このままではウィンが負けてしまいます。」というメッセージが表示されます。"
          ),
          p.text(
            "メッセージ内の「ウィン」の文字を10回タッチすることでメッセージを消して先に進むことができます。"
          ),
        ]
      ),
    ]),
  ]),
]);

const stepData2 = p.keywordStep("ロゼパネル", "ろぜぱねる")(
  "五十音クイズバトル　エクストラ",
  [
    p.foldable("ウィンが絶対勝ってしまう", [
      p.text("ウィンは5回目に必ず『かしわもち』を答えてしまいます。"),
      p.text("どうにかロゼに『かしわもち』とウィンより先に答えさせましょう。"),
      p.text(
        "解答に使われている5文字が分かれば、ロゼは問15にすぐに答えるとバトルルールに書いてあります。"
      ),
      p.showMore("もっと見る", "閉じる"),
      p.text(
        "どの順番で1~4回目に問題を解答したとしても『かしわもち』の5文字すべてを黄色く光らせることはできません。"
      ),
      p.text(
        "必要な文字を黄色く光らせる以外で、五十音パネルを使ってロゼに情報を伝える方法は無いでしょうか？"
      ),
      p.showMore("もっと見る", "閉じる"),
      p.text(
        "逆に、他の41文字すべてが灰色になり、残りが『かしわもち』の5文字だけになれば、ロゼも当たりの答えに使われている文字を特定することができます。"
      ),
      p.text(
        "そのためには答えの文字数が多い問題に解答し、多くの文字を灰色にする必要があります。"
      ),
      p.text("しかしふつうに答えていてもどうしても文字数が足りません。"),
      p.text(
        "どれかの問題で解答の文字数を大幅に増やすことはできないでしょうか？"
      ),
      p.showMore("もっと見る", "閉じる"),
      p.text("問7の答えは相子先生の名前になります。"),
      p.text(
        "相子先生の名前を本名で答えることができれば、解答の文字数を増やせそうです。"
      ),
      p.showMore("もっと見る", "閉じる"),
      p.text(
        "オマケ冊子の4コマを見ると、相子先生の本名は「笛野・オサセソ・テ・トニハヘ・ホム・ヲ・相子」だとわかります。"
      ),
      p.text(
        "これに加えて、ロゼがどの問題に答えるかも考えつつ、問題3問をうまく選んで『かしわもち』以外の五十音パネルを灰色にしましょう。"
      ),
      p.text(
        "ロゼは問題番号が小さいものから順番に答えていくので、問1から問3の問題は必ずウィンかロゼが答えることになります。"
      ),
      p.showMore("答えを見る", "閉じる"),
      p.text("1問目:ふえのおさせそてとにはへほむをあいこ"),
      p.text("2問目:めろす"),
      p.text("3問目:たぬき"),
      p.text("4問目:ひなまつり"),
      p.text("と答えれば、ロゼは『かしわもち』と答えてくれます。"),
    ]),

    p.text(" "),
    p.text(" "),
    p.foldable("すべての勝負に勝利した人はこちら", [
      p.text(
        "ここから先は重大なネタバレが含まれます。\nすべての勝負に勝利していない方は絶対に見ないでください。"
      ),
      p.foldable("ウィンが勝利した先のヒントを見る", [
        p.text(
          "ここから先は、ロゼを勝たせる方法を探している方向けの内容です。"
        ),
        p.text(
          "すべての勝負でロゼが勝利する方法を探している場合は、第一勝負『五十音クイズ』から順番に攻略することを強くオススメします。"
        ),
        p.text(
          "また、「？」の封筒を開いていない方は、封筒を開いて中身を確認してから考えてみましょう。"
        ),
        p.foldable("ロゼを勝たせる方法のヒントが見たい", [
          p.text(
            "ロゼを勝たせる方法のヒントがほしい方は各勝負のヒントキーワードの先頭に「ロゼ」をつけて入力してください。"
          ),
        ]),

        p.foldable(
          "ロゼを勝たせることはできたがメッセージが出てきて先に進めない",
          [
            p.text(
              "ロゼが勝ちそうになると「このままではウィンが負けてしまいます。」というメッセージが表示されます。"
            ),
            p.text(
              "メッセージ内の「ウィン」の文字を10回タッチすることでメッセージを消して先に進むことができます。"
            ),
          ]
        ),
      ]),
    ]),
  ]
);

const stepData3 = p.keywordStep("ホームラン", "ほーむらん")("レンタル野球", [
  p.foldable("何をすればいいかわからない", [
    p.text(
      "2nd Battleの封筒に入っている「学校探索シート」を見て、学校のどこに何があるのかを突き止めましょう"
    ),
    p.text(
      "それがわかったら、ロゼが投げてくるものに対してウィンが振るものを選び、Webサイトに入力しましょう。"
    ),
  ]),

  p.foldable("学校探索シートを見ても、それぞれの場所に何があるのかわからない", [
    p.foldable("グラウンドにあるものがわからない", [
      p.text("文字が並んだ盤面から、同じ線に囲まれたマスを探しましょう。"),
      p.text(
        "例えば、左側が赤の破線、上側がオレンジの波線のマスは、左から2番目、上から2番目にある「バ」のマスになります。"
      ),
      p.showMore("答えを見る", "閉じる"),
      p.text("グラウンドにあるものは『バット』です。"),
    ]),

    p.foldable("体育館にあるものがわからない", [
      p.text("実際に赤の破線を山折り、青の点線を谷折りしてみましょう。"),
      p.text("折るときは紙全体を、完全に折りたたんでください。"),
      p.text("そのときに見える文字を読むと「〇〇〇ガコタエダ」となります。"),
      p.showMore("答えを見る", "閉じる"),
      p.text("体育館にあるものは『テニスラケット』です。"),
    ]),

    p.foldable("図書室にあるものがわからない", [
      p.text(
        "「太」の文字と同じように太くなっている文字を探して上から読むと「バケツ」となります。"
      ),
      p.text(
        "「薄」の文字と同じように色が薄くなっている文字を探して上から読みましょう。"
      ),
      p.showMore("答えを見る", "閉じる"),
      p.text("図書室にあるものは『ホウキ』です。"),
    ]),

    p.foldable("家庭科室にあるものがわからない", [
      p.text("「砂糖」「大人」をひらがなにして考えましょう。"),
      p.showMore("もっと見る", "閉じる"),
      p.text(
        "「さとうの上」は「『さ』と『う』の上」、すなわち「サ」の文字と「ウ」の文字の上を読むということを表しています。"
      ),
      p.text("同じように、「オ」と「ナ」の上の文字を読んでみましょう。"),
      p.showMore("答えを見る", "閉じる"),
      p.text("家庭科室にあるものは『シオ』です。"),
    ]),

    p.foldable("理科室にあるものがわからない", [
      p.text("矢印の向きに傾いている文字を探して、左から読みましょう。"),
      p.showMore("答えを見る", "閉じる"),
      p.text("理科室にあるものは『スポンジ』です。"),
    ]),

    p.foldable("図工室にあるものがわからない", [
      p.text(
        "「仏」「公」を分解して、「イ」と「ム」、「ハ」と「ム」として考えましょう。"
      ),
      p.text("それらの文字の間を、矢印の向きに読んでみましょう。"),
      p.showMore("答えを見る", "閉じる"),
      p.text("図工室にあるものは『ジョウギ』です。"),
    ]),
  ]),

  p.foldable("何を振ればいいのかわからない", [
    p.text(
      "ウィンは「ロゼが投げてくるものに合ったものを振るとカッコイイかもな！」と言っています。その言葉に従って振るものを考えてみましょう。"
    ),
    p.text("下から1球ごとの具体的なヒントが見られます。"),
    p.foldable("1球目", [
      p.text(
        "ロゼは野球ボールを投げてきます。こちらも同じく野球で使う道具を振ってみましょう。"
      ),
      p.showMore("答えを見る", "閉じる"),
      p.text("『グラウンド』にある『バット』を振るとホームランが打てます。"),
    ]),

    p.foldable("2球目", [
      p.text(
        "ロゼはテニスボールを投げてきます。こちらも同じくテニスで使う道具を振ってみましょう。"
      ),
      p.showMore("答えを見る", "閉じる"),
      p.text(
        "『体育館』にある『テニスラケット』を振るとホームランが打てます。"
      ),
    ]),

    p.foldable("3球目", [
      p.text(
        "ロゼはぞうきんを投げてきます。こちらも同じく掃除用具を振ってみましょう。"
      ),
      p.showMore("答えを見る", "閉じる"),
      p.text("『図書室』にある『ホウキ』を振るとホームランが打てます。"),
    ]),

    p.foldable("4球目", [
      p.text(
        "ロゼが投げてくるペイントボールのインクがかからないようにするには、液体を吸い取ることができそうなものを振るとよいでしょう。"
      ),
      p.text("学校にあるもので、そのようなものはなかったでしょうか？"),
      p.showMore("答えを見る", "閉じる"),
      p.text(
        "『理科室』にある『スポンジ』を振ると、インクで汚れることなくホームランが打てます。"
      ),
    ]),

    p.foldable("5球目", [
      p.text(
        "ロゼはおにぎりを投げてきます。「おにぎりに合う」ものを振ってみましょう。"
      ),
      p.showMore("もっと見る", "閉じる"),
      p.text("『家庭科室』にある『シオ』を振ってみましょう。"),
      p.showMore("もっと見る", "閉じる"),
      p.text(
        "ウィンがおにぎりに塩を「振りかけて」しまい、やり直しになってしまいました。"
      ),
      p.text(
        "しかしウィンは「次はちゃんと打つぜ！」と言っているので、もう一度塩を振ればホームランを打ってくれそうです。"
      ),
      p.showMore("答えを見る", "閉じる"),
      p.text("『家庭科室』にある『シオ』を2回振るとホームランが打てます。"),
    ]),
  ]),

  p.text(" "),
  p.text(" "),
  p.foldable("すべての勝負に勝利した人はこちら", [
    p.text(
      "ここから先は重大なネタバレが含まれます。\nすべての勝負に勝利していない方は絶対に見ないでください。"
    ),
    p.foldable("ウィンが勝利した先のヒントを見る", [
      p.text("ここから先は、ロゼを勝たせる方法を探している方向けの内容です。"),
      p.text(
        "すべての勝負でロゼが勝利する方法を探している場合は、第一勝負『五十音クイズ』から順番に攻略することを強くオススメします。"
      ),
      p.text(
        "また、「？」の封筒を開いていない方は、封筒を開いて中身を確認してから考えてみましょう。"
      ),
      p.foldable("ロゼを勝たせる方法のヒントが見たい", [
        p.text(
          "ロゼを勝たせる方法のヒントがほしい方は各勝負のヒントキーワードの先頭に「ロゼ」をつけて入力してください。"
        ),
      ]),

      p.foldable(
        "ロゼを勝たせることはできたがメッセージが出てきて先に進めない",
        [
          p.text(
            "ロゼが勝ちそうになると「このままではウィンが負けてしまいます。」というメッセージが表示されます。"
          ),
          p.text(
            "メッセージ内の「ウィン」の文字を10回タッチすることでメッセージを消して先に進むことができます。"
          ),
        ]
      ),
    ]),
  ]),
]);

const stepData4 = p.keywordStep("ロゼホームラン", "ろぜほーむらん")(
  "レンタル野球　エクストラ",
  [
    p.foldable("ウィンが絶対勝ってしまう", [
      p.text(
        "どうやらウィンはどのボールに何を振ってもホームランを打ってしまうようです。"
      ),
      p.text(
        "ロゼがウィンをポイントで上回る以外にウィンが負ける方法がないか、これまでに手に入れた様々な情報から探してみましょう。"
      ),
      p.showMore("もっと見る", "閉じる"),
      p.text("オマケ冊子の4コマを見てみましょう。"),
      p.text(
        "その中に、勝負の内容に関わらずある行動をとると敗北になる、ということが書かれた4コマがあります。"
      ),
      p.showMore("もっと見る", "閉じる"),
      p.text(
        "4コマ漫画『白旗』に、「バトル中に白旗を振ったらそれは敗北を表す！」という掟が書かれています。"
      ),
      p.text(
        "勝負中にウィンに白旗を振らせることができれば、この掟に従ってウィンの敗北、すなわちロゼの勝利となりそうです。"
      ),
    ]),

    p.foldable("ウィンが負ける方法が分かったが、必要なものが見つからない", [
      p.text(
        "ウィンに白旗を振らせるために、「旗」がどこにあるのかを突き止めなければなりません。"
      ),
      p.text("しかし、学校探索シートを見ても旗がどこにあるかはわかりません。"),
      p.text("あなたは「旗」をどこか別の場所で見ているはずです。"),
      p.showMore("もっと見る", "閉じる"),
      p.text(
        "他の勝負の中で、「旗」が登場するものがあります。キットをよく探してみましょう。"
      ),
      p.showMore("答えを見る", "閉じる"),
      p.text("『学校すごろく』のゴール地点である屋上に、旗があります。"),
      p.text(
        "屋上にあるということは学校の中にあるものなので、この旗をウィンに振らせることができそうです。"
      ),
    ]),

    p.foldable(
      "必要なものは見つかったが、それを使ってどうすればいいかわからない",
      [
        p.text("旗が屋上にあることはわかりましたが、この旗は白くありません。"),
        p.text("ウィンに負けさせるにはこの旗を白くする必要があります。"),
        p.showMore("もっと見る", "閉じる"),
        p.text(
          "旗を白く染められそうなもの、例えば白いインクなどはどこかに無かったでしょうか？"
        ),
        p.showMore("もっと見る", "閉じる"),
        p.text(
          "ロゼは4球目に白いインクが大量に詰まったペイントボールを投げてきます。"
        ),
        p.text(
          "それに対して旗を振れば、旗に白いインクがかかり、「白旗」になりそうです。"
        ),
        p.text("実際に試してみましょう。"),
        p.showMore("答えを見る", "閉じる"),
        p.text(
          "4球目で「屋上」にある「旗」を振ると、ウィンが白旗を振ったと判定されます。"
        ),
      ]
    ),

    p.text(" "),
    p.text(" "),
    p.foldable("すべての勝負に勝利した人はこちら", [
      p.text(
        "ここから先は重大なネタバレが含まれます。\nすべての勝負に勝利していない方は絶対に見ないでください。"
      ),
      p.foldable("ウィンが勝利した先のヒントを見る", [
        p.text(
          "ここから先は、ロゼを勝たせる方法を探している方向けの内容です。"
        ),
        p.text(
          "すべての勝負でロゼが勝利する方法を探している場合は、第一勝負『五十音クイズ』から順番に攻略することを強くオススメします。"
        ),
        p.text(
          "また、「？」の封筒を開いていない方は、封筒を開いて中身を確認してから考えてみましょう。"
        ),
        p.foldable("ロゼを勝たせる方法のヒントが見たい", [
          p.text(
            "ロゼを勝たせる方法のヒントがほしい方は各勝負のヒントキーワードの先頭に「ロゼ」をつけて入力してください。"
          ),
        ]),

        p.foldable(
          "ロゼを勝たせることはできたがメッセージが出てきて先に進めない",
          [
            p.text(
              "ロゼが勝ちそうになると「このままではウィンが負けてしまいます。」というメッセージが表示されます。"
            ),
            p.text(
              "メッセージ内の「ウィン」の文字を10回タッチすることでメッセージを消して先に進むことができます。"
            ),
          ]
        ),
      ]),
    ]),
  ]
);

const stepData5 = p.keywordStep("サイコロ", "さいころ")("学校すごろく", [
  p.foldable("何をすればいいかわからない", [
    p.text(
      "12枚の謎ピースをウィンが6枚の謎に組み合わせてくれたようです。封筒の中に入っていた6枚の謎を解きましょう。"
    ),
  ]),

  p.foldable("6枚の謎が解けない", [
    p.foldable("裏面が『7-6』の謎", [
      p.text("元の図形からいくつかの青い四角が無くなっているようです。"),
      p.text("何か文字のように見えないでしょうか。"),
      p.showMore("もっと見る", "閉じる"),
      p.text("白い部分を読んでみましょう。"),
      p.text("アルファベット4文字が浮かび上がります。"),
      p.showMore("答えを見る", "閉じる"),
      p.text("答えは『ストップ』です。"),
    ]),

    p.foldable("裏面が『5-3』の謎", [
      p.text("「ど」から始まる7つのものがグループになっています。"),
      p.text("赤い矢印と青い矢印に当てはまるものをそれぞれ考えてみましょう。"),
      p.showMore("もっと見る", "閉じる"),
      p.text("赤い矢印は音階、青い矢印は曜日を表しています。"),
      p.showMore("答えを見る", "閉じる"),
      p.text("答えは『れんらく』です。"),
    ]),

    p.foldable("裏面が『4-1』の謎", [
      p.text("左の四角は五十音表を表しています。"),
      p.text("それぞれの色に対応した文字を抜き出してみましょう。"),
      p.showMore("もっと見る", "閉じる"),
      p.text("赤・緑・黄色に対応した文字をカタカナで書いてみましょう。"),
      p.text("3つの漢字ができあがります。"),
      p.showMore("もっと見る", "閉じる"),
      p.text("できる漢字は「仁」「仏」「伝」です。"),
      p.text("これらの漢字の読み方を、音読みで当てはめてみましょう。"),
      p.showMore("答えを見る", "閉じる"),
      p.text("答えは『てつぶん』です。"),
    ]),

    p.foldable("裏面が『6-2』の謎", [
      p.text("左の図はあみだくじを表しています。"),
      p.showMore("もっと見る", "閉じる"),
      p.text(
        "緑の矢印が通る文字は「きーぼーど」、黄色の矢印が通る文字は「そーせーじ」です。"
      ),
      p.text("赤の矢印が通る文字を読んでみましょう。"),
      p.showMore("答えを見る", "閉じる"),
      p.text("答えは『うーぱーるーぱー』です。"),
    ]),

    p.foldable("裏面が『9-4』の謎", [
      p.text("4つのピースを右のマスに配置しましょう。"),
      p.text("縦に5つつながったピースは左下に入ります。"),
      p.showMore("もっと見る", "閉じる"),
      p.text("「し」のような形のピースは右下に入ります。"),
      p.text("残りのピースを埋めて、空いた2マスを上から読みましょう。"),
      p.showMore("答えを見る", "閉じる"),
      p.text("答えは『した』です。"),
    ]),

    p.foldable("裏面が『16-8』の謎", [
      p.text("ことばリストのことばを左のマスに埋めましょう。"),
      p.text("5文字のことばは「にっちょく」の1つだけですね。"),
      p.showMore("もっと見る", "閉じる"),
      p.text(
        "「し」のような形のマスには「にっちょく」、「くじら」、「てら」が入ります。"
      ),
      p.text(
        "残りのことばをもう1つのマスに埋めて、余ったことばを答えましょう。"
      ),
      p.showMore("答えを見る", "閉じる"),
      p.text("答えは『からて』です。"),
    ]),
  ]),

  p.foldable("謎は解けたが、どの答えから入力すればいいかわからない", [
    p.text(
      "ウィンはこの勝負に絶対に勝てるように謎ピースを組み合わせてくれました。"
    ),
    p.text("ウィンを信頼して、好きな順番で答えを入力しましょう。"),
  ]),

  p.text(" "),
  p.text(" "),
  p.foldable("すべての勝負に勝利した人はこちら", [
    p.text(
      "ここから先は重大なネタバレが含まれます。\nすべての勝負に勝利していない方は絶対に見ないでください。"
    ),
    p.foldable("ウィンが勝利した先のヒントを見る", [
      p.text("ここから先は、ロゼを勝たせる方法を探している方向けの内容です。"),
      p.text(
        "すべての勝負でロゼが勝利する方法を探している場合は、第一勝負『五十音クイズ』から順番に攻略することを強くオススメします。"
      ),
      p.text(
        "また、「？」の封筒を開いていない方は、封筒を開いて中身を確認してから考えてみましょう。"
      ),
      p.foldable("ロゼを勝たせる方法のヒントが見たい", [
        p.text(
          "ロゼを勝たせる方法のヒントがほしい方は各勝負のヒントキーワードの先頭に「ロゼ」をつけて入力してください。"
        ),
      ]),

      p.foldable(
        "ロゼを勝たせることはできたがメッセージが出てきて先に進めない",
        [
          p.text(
            "ロゼが勝ちそうになると「このままではウィンが負けてしまいます。」というメッセージが表示されます。"
          ),
          p.text(
            "メッセージ内の「ウィン」の文字を10回タッチすることでメッセージを消して先に進むことができます。"
          ),
        ]
      ),
    ]),
  ]),
]);

const stepData6 = p.keywordStep("ロゼサイコロ", "ろぜさいころ")(
  "学校すごろく　エクストラ",
  [
    p.foldable("ウィンが絶対勝ってしまう", [
      p.text(
        "ウィンが組み合わせた謎をどの順番で答えても、ルーレットの効果によって必ず5ターン目にSTOPマスに到達してしまいます。"
      ),
      p.text(
        "そこから少しでも前に進もうとすると、ルーレットの「×100」の効果により必ずゴールしてしまいます。"
      ),
      p.showMore("もっと見る", "閉じる"),
      p.text(
        "もし、裏面の数式の答えがマイナスの数になる謎があり、それを6ターン目に答えるとどうなるでしょうか。"
      ),
      p.text(
        "例えば、裏面の数式の答えが「-1」の謎に答えるとすると、6ターン目にSTOPマスから「-100マス」進むことになります。"
      ),
      p.showMore("もっと見る", "閉じる"),
      p.text(
        "STOPマスから-100マス進む、つまり100マス戻るとふりだしまで戻ってしまいます。"
      ),
      p.text(
        "「ふりだしに戻ってしまったらその時点で敗北」になるというルールがあるため、そうすればウィンが敗北し、ロゼを勝たせることができます。"
      ),
      p.text(
        "どうにかして数式の答えがマイナスの数になる謎に答えられないでしょうか。"
      ),
    ]),

    p.foldable(
      "ウィンが負ける方法が分かったが、ここから何をすればいいのかわからない",
      [
        p.foldable("数式の答えがマイナスの数になる謎に答える方法がわからない", [
          p.text(
            "先生から渡されたのは12枚の謎ピースです。ウィンはこれらを「勝てるように」組み合わせて6枚の謎を作りました。"
          ),
          p.showMore("もっと見る", "閉じる"),
          p.text("今の組み合わせだと絶対に勝ってしまうようです。"),
          p.text("謎ピースを組み替えて他の謎を作ることはできないでしょうか。"),
          p.showMore("もっと見る", "閉じる"),
          p.text("バラバラにするべき謎は「9-4」の謎と「16-8」の謎です。"),
          p.showMore("もっと見る", "閉じる"),
          p.text(
            "裏表や上下に注意し、『9-7』の謎と『16-17』の謎を作りましょう。"
          ),
        ]),

        p.foldable(
          "数式の答えがマイナスになる謎、またはもう一つの謎の答えがわからない",
          [
            p.foldable("裏面が『9-7』の謎", [
              p.text("4つのピースを右のマスに配置しましょう。"),
              p.text("「8」の形のピースは左下に入ります。"),
              p.text("残りのピースを埋めて、空いた2マスを上から読みましょう。"),
              p.showMore("答えを見る", "閉じる"),
              p.text("答えは『こつ』です。"),
            ]),

            p.foldable("裏面が『16-17』の謎", [
              p.text("ことばリストのことばを左のマスに埋めましょう。"),
              p.text(
                "「h」のような形のマスには「にっちょく」、「ちょこ」、「こころ」が入ります。"
              ),
              p.text(
                "残りのことばをもう1つのマスに埋めて、余ったことばを答えましょう。"
              ),
              p.showMore("答えを見る", "閉じる"),
              p.text("答えは『ろく』です。"),
            ]),
          ]
        ),

        p.foldable("負ける方法を見る", [
          p.text(
            "6ターン目に数式の答えがマイナスの数になる謎を答えることで負けることができます。"
          ),
          p.text("まずは裏面が「16-17」の謎以外の5問に答えましょう。"),
          p.text(
            "6ターン目に『16-17』の謎の答え、『ろく』を答えてふりだしまで戻りましょう。"
          ),
        ]),
      ]
    ),

    p.text(" "),
    p.text(" "),
    p.foldable("すべての勝負に勝利した人はこちら", [
      p.text(
        "ここから先は重大なネタバレが含まれます。\nすべての勝負に勝利していない方は絶対に見ないでください。"
      ),
      p.foldable("ウィンが勝利した先のヒントを見る", [
        p.text(
          "ここから先は、ロゼを勝たせる方法を探している方向けの内容です。"
        ),
        p.text(
          "すべての勝負でロゼが勝利する方法を探している場合は、第一勝負『五十音クイズ』から順番に攻略することを強くオススメします。"
        ),
        p.text(
          "また、「？」の封筒を開いていない方は、封筒を開いて中身を確認してから考えてみましょう。"
        ),
        p.foldable("ロゼを勝たせる方法のヒントが見たい", [
          p.text(
            "ロゼを勝たせる方法のヒントがほしい方は各勝負のヒントキーワードの先頭に「ロゼ」をつけて入力してください。"
          ),
        ]),

        p.foldable(
          "ロゼを勝たせることはできたがメッセージが出てきて先に進めない",
          [
            p.text(
              "ロゼが勝ちそうになると「このままではウィンが負けてしまいます。」というメッセージが表示されます。"
            ),
            p.text(
              "メッセージ内の「ウィン」の文字を10回タッチすることでメッセージを消して先に進むことができます。"
            ),
          ]
        ),
      ]),
    ]),
  ]
);

const stepData7 = p.keywordStep("サーチ", "さーち")(
  "カルテットストライカーズ",
  [
    p.foldable("何をすればいいかわからない", [
      p.text(
        "封筒の中に入っていた謎を解いてカード7枚の効果を求めましょう。 それが終わったらルールの紙にキーワードを埋める欄があるので埋めましょう。"
      ),
    ]),

    p.foldable("キーワードを埋めるための謎が解けない", [
      p.foldable("Q1", [
        p.text(
          "上のイラストは「タタミ」、下のイラストは「ドレス」を表しています。"
        ),
        p.text(
          "また青矢印と赤矢印は文字をそれぞれ異なるとある順番でずらすことを表しています。"
        ),
        p.showMore("もっと見る", "閉じる"),
        p.text(
          "青矢印ではドレミファソラシドの順、赤矢印では五十音順に、矢印の数だけ文字をずらしましょう。"
        ),
        p.text("「シシシ」→「ドレス」の法則を例に考えてみます。"),
        p.text(
          "「し」をドレミで上に1つずらすと「ど」、「し」をドレミで上に2つずらすと「れ」、「し」を五十音で下に1つずらすと「す」になりますね。"
        ),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『ミドリ』です。"),
      ]),

      p.foldable("Q2", [
        p.text("4つの十字を結んで四角を書いてみましょう"),
        p.text("白い部分が何かの漢字に見えそうです。"),
        p.showMore("もっと見る", "閉じる"),
        p.text("左は「王」という漢字に、真ん中は「円」という漢字に見えます。"),
        p.text("答えは漢数字になります。"),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『ヨン』です。"),
      ]),

      p.foldable("Q3", [
        p.text("「ふ」「つ」「く」に目が付いています。"),
        p.text("目線の先には「みや」「しか」があるようですね。"),
        p.text("五十音表を思い浮かべると良いかもしれません。"),
        p.showMore("もっと見る", "閉じる"),
        p.text("五十音表で「ふ」の左上には「み」と「や」があります。"),
        p.text("また「つ」の右上には「し」と「か」があります。"),
        p.text("では「く」の左上にある文字はなんでしょう。"),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『シタ』です。"),
      ]),

      p.foldable("Q4", [
        p.text("1234の数字に『バツグン』と実際に当てはめてみましょう。"),
        p.text("左のイラストの縦の列には「バッグ」が当てはまるようです。"),
        p.text("また右のイラストの縦の列には「バ？？ン」と当てはまりますね。"),
        p.text("左と右のイラストをそれぞれ2通りの言い方で考えましょう。"),
        p.showMore("もっと見る", "閉じる"),
        p.text(
          "「カバン」と「バッグ」を左のイラストに、「フウセン」と「バルーン」を右のイラストに当てはめて、数字の場所を読んでみましょう。"
        ),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『カプセル』です。"),
      ]),

      p.foldable("Q5", [
        p.text(
          "一見アルファベットに見えますが、アルファベットではありません。"
        ),
        p.text("紙の向きを90°変えて見てみましょう。"),
        p.showMore("もっと見る", "閉じる"),
        p.text("紙を左に90°傾けることでカタカナとして読むことができます。"),
        p.text(
          "上は「ココロ」、真ん中は「エー」、下は「コード」のイラストです。"
        ),
        p.text("矢印の先のカタカナを順に読みましょう。"),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『ロード』です。"),
      ]),

      p.foldable("Q6", [
        p.text(
          "左のイラストは、それぞれ「タバコ」「アイス」「ニホン」を表しています。"
        ),
        p.text("それぞれのイラストは全て何かが欠けているようですね。"),
        p.showMore("もっと見る", "閉じる"),
        p.text(
          "「タバコ」のイラストから真ん中の「バ」の部分が抜けて「タコ」になっています。"
        ),
        p.text(
          "同様に「イ」「ニ」の部分が抜けて「アス」「ホン」になっていますね。"
        ),
        p.text(
          "どうやら、イラストの抜けている部分を並べたものが答えになるようです。"
        ),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『ニバイ』です。"),
      ]),

      p.foldable("Q7", [
        p.text("ゴロゴロピカピカといえば、かみなりですね。"),
        p.text(
          "サンダー、いなづまなど、色々言いかえて、中に「かず」が入る言い方を探してみましょう。"
        ),
        p.showMore("もっと見る", "閉じる"),
        p.text("上から「いかずち」「いなかまち」「いばらのみち」となります。"),
        p.text("答えは数字になります。"),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『イチ』です。"),
      ]),

      p.foldable("Q8", [
        p.text("ハートと月のイラストが重なっています。"),
        p.text("月を「ムーン」と読んでみましょう。"),
        p.showMore("もっと見る", "閉じる"),
        p.text(
          "「ハート」と「ムーン(月)」が重なっており、仕切られた図形がそれぞれ「ハ」「ー」「ト」「ム」「ン」に対応しています。"
        ),
        p.text(
          "重なっている部分が「ー」に対応しており、また下に並んだ図形は左から「ハ」「ハ」「ム」「ー」「ト」に対応しています。"
        ),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『バハムート』です。"),
      ]),
    ]),

    p.foldable("謎をすべて解いたがその先がわからない。", [
      p.foldable("キーワードがわからない", [
        p.text(
          "謎を8問解いて対応するアルファベットを埋めると、キーワードが「カードバトルタイセンカイシ」だと分かります。"
        ),
        p.text("キーワードをWebページに入力しましょう。"),
      ]),

      p.foldable("キーワードを入力したがその先がわからない", [
        p.text(
          "まずは封止めされた紙の中に書かれた追加情報をよく読んで、ロゼが使うカードを確認しましょう。"
        ),
        p.text(
          "そしてウィンが使用する3枚のカードを考えて、Webページに入力しましょう。"
        ),
        p.text("紙のおすすめ情報を参考にしても良いかもしれません。"),
        p.showMore("答えを見る", "閉じる"),
        p.text("おすすめ情報に沿って考えると、"),
        p.text(
          "1枚目:グリーンマジシャン 2枚目:レッドオリオン 3枚目:レッドヘビーロード を使用すると勝てそうです。"
        ),
        p.text("入力が完了したら勝負開始ボタンを押しましょう。"),
      ]),
    ]),

    p.text(" "),
    p.text(" "),
    p.foldable("すべての勝負に勝利した人はこちら", [
      p.text(
        "ここから先は重大なネタバレが含まれます。\nすべての勝負に勝利していない方は絶対に見ないでください。"
      ),
      p.foldable("ウィンが勝利した先のヒントを見る", [
        p.text(
          "ここから先は、ロゼを勝たせる方法を探している方向けの内容です。"
        ),
        p.text(
          "すべての勝負でロゼが勝利する方法を探している場合は、第一勝負『五十音クイズ』から順番に攻略することを強くオススメします。"
        ),
        p.text(
          "また、「？」の封筒を開いていない方は、封筒を開いて中身を確認してから考えてみましょう。"
        ),
        p.foldable("ロゼを勝たせる方法のヒントが見たい", [
          p.text(
            "ロゼを勝たせる方法のヒントがほしい方は各勝負のヒントキーワードの先頭に「ロゼ」をつけて入力してください。"
          ),
        ]),

        p.foldable(
          "ロゼを勝たせることはできたがメッセージが出てきて先に進めない",
          [
            p.text(
              "ロゼが勝ちそうになると「このままではウィンが負けてしまいます。」というメッセージが表示されます。"
            ),
            p.text(
              "メッセージ内の「ウィン」の文字を10回タッチすることでメッセージを消して先に進むことができます。"
            ),
          ]
        ),
      ]),
    ]),
  ]
);

const stepData8 = p.keywordStep("ロゼサーチ", "ろぜさーち")(
  "カルテットストライカーズ　エクストラ",
  [
    p.foldable("ウィンが絶対勝ってしまう", [
      p.text(
        "「レッドバハムート」より高い攻撃力を持つカードがロゼのカードになければ、ロゼが勝つことはできません。"
      ),
      p.text(
        "ウィンのカードの攻撃力を下げることができるカードはないようです。"
      ),
      p.text(
        "逆に、ロゼのカードの攻撃力を上げることのできるカードは手元に無いでしょうか？"
      ),
      p.showMore("もっと見る", "閉じる"),
      p.text(
        "ウィンの手札の中で、ロゼのカードの攻撃力を上げることができるカードは「レッドヘビーロード」だけです。"
      ),
      p.text(
        "もしこの効果で「ブルードラゴン」の攻撃力を2倍にすることができれば「レッドバハムート」を倒せそうですね。"
      ),
      p.text(
        "しかし「ブルードラゴン」の名前には「ロード」が含まれていません。"
      ),
      p.text(
        "この効果を、「ブルードラゴン」に作用させることはできないでしょうか？"
      ),
      p.showMore("もっと見る", "閉じる"),
      p.text(
        "例えば、ロゼのイエローライトロードが負けたときは、ウィンの勝ったカードの色が青に変わり、名前の色の部分も「ブルー」に変わっていましたね。"
      ),
      p.text(
        "対戦中にカードの色が変化すると、同時にカードの名前も変化していました。"
      ),
      p.text(
        "これをうまく活用し、「ブルードラゴン」の色を変えて、名前に「ロード」を含むようにはできないでしょうか。"
      ),
      p.showMore("もっと見る", "閉じる"),
      p.text(
        "「ブルードラゴン」が黄色く変化すると名前は「イエロードラゴン」に変わり、名前に「ロード」が含まれるようになります。"
      ),
      p.text(
        "では、「ブルードラゴン」を黄色に変化させるにはどうすればよいでしょうか。"
      ),
      p.text(
        "ウィンの持つカードから相手のカードの色を変えられるカードを探してみましょう"
      ),
      p.showMore("答えを見る", "閉じる"),
      p.text(
        "「グリーンマジシャン」を使って「ブルードラゴン」の色を黄色に変えましょう。"
      ),
    ]),

    p.foldable("ロゼを勝たせる方法はわかったが、必要なものが見つからない", [
      p.text(
        "「グリーンマジシャン」の効果で「ブルードラゴン」の色を変えて「イエロードラゴン」に変化させることができれば、ロゼはウィンに勝つことができます。"
      ),
      p.text(
        "ただ、そのためにはウィンのデッキに黄色いカードがなければなりませんが、封筒から出てきたカードの中に黄色いカードはありません。"
      ),
      p.text(
        "どこかにウィンが持つ黄色いカードの手がかりはなかったでしょうか。"
      ),
      p.showMore("もっと見る", "閉じる"),
      p.text(
        "追加情報には、ウィンの持っているカードなら「なんでも」使っていいと書かれています。"
      ),
      p.text("7枚のカード以外にも、ウィンはカードを持っているかもしれません。"),
      p.text(
        "クリア後に見られるオマケ冊子の8ページ目に重要な手がかりがあります。"
      ),
      p.showMore("もっと見る", "閉じる"),
      p.text("ウィンは常にサッカーの審判道具を持っているようです。"),
      p.text("サッカーの審判道具には「黄色いカード」があります。"),
      p.showMore("答えを見る", "閉じる"),
      p.text("ウィンは「イエローカード」を常に持っています。"),
      p.text("「イエローカード」を使いましょう。"),
      p.text("1枚目:グリーンマジシャン"),
      p.text("2枚目:イエローカード"),
      p.text("3枚目:レッドヘビーロード"),
      p.text("を使用すると良さそうです。"),
    ]),

    p.text(" "),
    p.text(" "),
    p.foldable("すべての勝負に勝利した人はこちら", [
      p.text(
        "ここから先は重大なネタバレが含まれます。\nすべての勝負に勝利していない方は絶対に見ないでください。"
      ),
      p.foldable("ウィンが勝利した先のヒントを見る", [
        p.text(
          "ここから先は、ロゼを勝たせる方法を探している方向けの内容です。"
        ),
        p.text(
          "すべての勝負でロゼが勝利する方法を探している場合は、第一勝負『五十音クイズ』から順番に攻略することを強くオススメします。"
        ),
        p.text(
          "また、「？」の封筒を開いていない方は、封筒を開いて中身を確認してから考えてみましょう。"
        ),
        p.foldable("ロゼを勝たせる方法のヒントが見たい", [
          p.text(
            "ロゼを勝たせる方法のヒントがほしい方は各勝負のヒントキーワードの先頭に「ロゼ」をつけて入力してください。"
          ),
        ]),

        p.foldable(
          "ロゼを勝たせることはできたがメッセージが出てきて先に進めない",
          [
            p.text(
              "ロゼが勝ちそうになると「このままではウィンが負けてしまいます。」というメッセージが表示されます。"
            ),
            p.text(
              "メッセージ内の「ウィン」の文字を10回タッチすることでメッセージを消して先に進むことができます。"
            ),
          ]
        ),
      ]),
    ]),
  ]
);

const stepData9 = p.keywordStep("ニッキ", "にっき")("ナゾトキしりとり", [
  p.foldable("何をすればいいかわからない", [
    p.text(
      "ナゾトキしりとりのルールにそって、謎の答えでしりとりをしていきましょう。"
    ),
    p.text(
      "現在答えることができる謎は、Webページの下の方にまとめられています。"
    ),
    p.text("その中から謎を1つ選んで解き、答えを解答欄に入力しましょう。"),
  ]),

  p.foldable("1つ1つの謎が解けない", [
    p.foldable("答えが「せ」から始まる謎", [
      p.foldable("Aの謎", [
        p.text("ずばり、下の4文字には「せんせい」が当てはまります。"),
        p.text(
          "同じ数字に同じ文字を当てはめると、上の6文字は「？？ねんせい」となります。"
        ),
        p.showMore("もっと見る", "閉じる"),
        p.text("上の6文字には2人の学年が当てはまります。"),
        p.text(
          "箱を開けて最初に入っていた紙のキャラ紹介を見ると、2人は6年生であることがわかります。"
        ),
        p.text("「ろくねんせい」を当てはめて、答えの数字を読みましょう。"),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『せんろ』です。"),
      ]),

      p.foldable("Bの謎", [
        p.text(
          "「バーコード」は「バ」「コ」「ド」を線で結ぶことを意味しています。"
        ),
        p.text("結んでみると、線が「しろくろ」の文字を通ることがわかります。"),
        p.text(
          "同じように「キ」「ワ」「ド」を線で結び、通る文字を読んでみましょう。"
        ),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『せみぷろ』です。"),
      ]),

      p.foldable("Cの謎", [
        p.text(
          "青い点線が引かれている部分をアルファベット、赤い直線が引かれている部分を数字として見てみましょう。"
        ),
        p.showMore("もっと見る", "閉じる"),
        p.text(
          "上側の枠には左から「オ―」「アイ」「ビー」、下側の枠には左から「ゼロ」「イチ」「サン」が当てはまります。"
        ),
        p.text(
          "2の文字に半濁点がついていることに気を付けて、文字を当てはめて答えを導きましょう。"
        ),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『せぴあいろ』です。"),
      ]),

      p.foldable("Dの謎", [
        p.text("人に対する空間の大きさを表す言葉が当てはまります。"),
        p.showMore("もっと見る", "閉じる"),
        p.text(
          "左は人に対して空間が小さいため「せまい」、右は空間が大きいため「ひろい」が当てはまります。"
        ),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『せびろ』です。"),
      ]),

      p.foldable("カルテットストライカーズのアイコンの謎", [
        p.text(
          "『カルテットストライカーズ』で使用したカードを見て、カードの攻撃力で計算をしましょう。"
        ),
        p.text(
          "レッドヘビーロードの攻撃力は6、パープルロータスの攻撃力は9、足すと15になります。"
        ),
        p.text(
          "下にある表を見ると、1は「ナ」、5は「ゾ」に対応しており、15は「ナゾ」になることがわかります。"
        ),
        p.text("同じように下の式も計算しましょう。"),
        p.showMore("もっと見る", "閉じる"),
        p.text(
          "「勝ち残ったカード」はウィンが4枚目に使ったレッドバハムートで、攻撃力は99です。"
        ),
        p.text(
          "また、パープルジェントルの攻撃力は7、グリーンゴーレムの攻撃力は4です。"
        ),
        p.text("これらの数字を式に当てはめると「99×7-4」となります。"),
        p.showMore("もっと見る", "閉じる"),
        p.text("計算すると、689になります。"),
        p.text("表を使って、数字から文字に変換しましょう。"),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『せいろ』です。"),
      ]),
    ]),

    p.foldable("答えが「い」から始まる謎", [
      p.foldable("Eの謎", [
        p.text(
          "「？」に動物の名前を当てはめて、このイラストを表す言葉にしましょう。"
        ),
        p.text(
          "このイラストが表しているのは、100年後、つまり「未来」から来た「ししゃも」のようです。"
        ),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『いのしし』です。"),
      ]),

      p.foldable("Fの謎", [
        p.text("上に並んだ7つのイラストが「シンカノカテイ」を表しています。"),
        p.text("「シンカノカテイ」もちょうど7文字ですね。"),
        p.showMore("もっと見る", "閉じる"),
        p.text(
          "7つのイラストにそれぞれ「シンカノカテイ」の文字が当てはまります。"
        ),
        p.text(
          "下の4つのイラストと同じイラストを探して、当てはまる文字を読みましょう。"
        ),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『いでんし』です。"),
      ]),

      p.foldable("Gの謎", [
        p.text(
          "赤い四角には2文字のひらがなが、青い四角には2文字のアルファベットが当てはまります。"
        ),
        p.showMore("もっと見る", "閉じる"),
        p.text("青い四角に当てはまるアルファベットは「ST」です。"),
        p.text(
          "「STONE」「START」「STOP」を色々な形で日本語に直してみましょう。"
        ),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『いし』です。"),
      ]),

      p.foldable("Hの謎", [
        p.text("並んだ図形のうち、矢印が指す側の半分だけを見てみましょう。"),
        p.text("矢印が左を差している場合は、図形の左半分を見ます。"),
        p.showMore("もっと見る", "閉じる"),
        p.text("図形の半分がカタカナのような形になっています。"),
        p.text("一番左の図形の左半分を見ると「イ」と読めそうです。"),
        p.text("他の図形も同じように読んでみましょう。"),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『いちおし』です。"),
      ]),

      p.foldable("五十音クイズバトルのアイコンの謎", [
        p.text(
          "『五十音クイズバトル』が終わった後、ウィンは「ひなあられ」をもらっていました。"
        ),
        p.text(
          "「ひ」「な」「あ」「ら」「れ」の文字を黄色くし、ルールにそってSからGまで進みましょう。"
        ),
        p.showMore("もっと見る", "閉じる"),
        p.text("まずはSから下方向に進み、「い」のマスまで進みます。"),
        p.text(
          "次に進むことができるのは右方向のみなので、そちらに進みましょう。"
        ),
        p.showMore("もっと見る", "閉じる"),
        p.text("「ら」が黄色く塗られているため、「も」のマスで止まります。"),
        p.text("次は上方向に進み、「む」のマスで止まります。"),
        p.text("同じようにして、Gまで進みましょう。"),
        p.showMore("もっと見る", "閉じる"),
        p.text(
          "「い」「も」「む」「し」のマスで曲がってGのマスまでたどり着くことができます。"
        ),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『いもむし』です。"),
      ]),

      p.foldable("レンタル野球のアイコンの謎", [
        p.text(
          "『レンタル野球』の勝負でロゼが最後に投げたものは、おにぎりでした。"
        ),
        p.text(
          "おにぎりの指示「太い文字、右から」に従って文字を探して読みましょう。"
        ),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『いつつぼし』です。"),
      ]),

      p.foldable("学校すごろくのアイコンの謎", [
        p.text("『学校すごろく』で使用したすごろくボードを見て解きましょう。"),
        p.text(
          "ウィンが最後にいた場所はゴールのマス、つまり旗が写っているところです。"
        ),
        p.showMore("もっと見る", "閉じる"),
        p.text(
          "3番目に通った場所は一番右の画像に写ったマス、2番目に通った場所は一番下の画像に写ったマスです。"
        ),
        p.text(
          "3つの画像の中心を線で結び、できた三角形の中にある文字をならびかえましょう。"
        ),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『いわし』です。"),
      ]),
    ]),
  ]),

  p.text(" "),
  p.text(" "),
  p.foldable("すべての勝負に勝利した人はこちら", [
    p.text(
      "ここから先は重大なネタバレが含まれます。\nすべての勝負に勝利していない方は絶対に見ないでください。"
    ),
    p.foldable("ウィンが勝利した先のヒントを見る", [
      p.text("ここから先は、ロゼを勝たせる方法を探している方向けの内容です。"),
      p.text(
        "すべての勝負でロゼが勝利する方法を探している場合は、第一勝負『五十音クイズ』から順番に攻略することを強くオススメします。"
      ),
      p.text(
        "また、「？」の封筒を開いていない方は、封筒を開いて中身を確認してから考えてみましょう。"
      ),
      p.foldable("ロゼを勝たせる方法のヒントが見たい", [
        p.text(
          "ロゼを勝たせる方法のヒントがほしい方は各勝負のヒントキーワードの先頭に「ロゼ」をつけて入力してください。"
        ),
      ]),

      p.foldable(
        "ロゼを勝たせることはできたがメッセージが出てきて先に進めない",
        [
          p.text(
            "ロゼが勝ちそうになると「このままではウィンが負けてしまいます。」というメッセージが表示されます。"
          ),
          p.text(
            "メッセージ内の「ウィン」の文字を10回タッチすることでメッセージを消して先に進むことができます。"
          ),
        ]
      ),
    ]),
  ]),
]);

const stepData10 = p.keywordStep("ロゼニッキ", "ろぜにっき")(
  "ナゾトキしりとり　エクストラ",
  [
    p.foldable("他の4つの勝負の中に、まだロゼが勝っていないものがある", [
      p.text(
        "『ナゾトキしりとり』でロゼを勝たせるには、ここまでの4つの勝負すべてでロゼが勝っている必要があります。"
      ),
      p.text(
        "まだロゼが勝っていない勝負がある場合は、Webページ右上のメニューからすべての勝負をやり直してください。"
      ),
    ]),

    p.foldable("ロゼを勝たせるために何をすればいいかわからない", [
      p.text(
        "まずは、勝った時と同じように謎を解いてしりとりをしてみましょう。"
      ),
      p.text("すると、1回目とは違った展開になります。"),
      p.text("まずはなぜそのような変化が起きたのか考えてみましょう。"),
      p.foldable("何が変わったのかわからない", [
        p.text(
          "1回目のしりとりでは、ロゼが「ボクは今日一日」から始まる日記を書いた日に「ロンドン」と答えてしりとりが終了していました。"
        ),
        p.text("しかし、今回はそれよりも長くしりとりが続いています。"),
        p.text(
          "また、Webページに表示される「答えが『せ』から始まる謎」や「答えが『い』から始まる謎」の数が減っています。"
        ),
        p.text(
          "オマケ冊子にある謎の一覧を見て、なぜそのような変化が起きたのか考えてみましょう。"
        ),
      ]),

      p.foldable("何が変わったのかはわかったが、変わった理由がわからない", [
        p.text(
          "『五十音クイズバトル』や『レンタル野球』など、これまでの勝負のアイコンがついている謎が、ウィンの解答手番でWebページ上に表示されなくなっています。"
        ),
        p.text(
          "それらの勝負でロゼを勝たせたことで、勝負の内容にどのような変化が起きたのかを思い出してもう一度それらの問題を解いてみましょう。"
        ),
        p.text(
          "ヒントが欲しい場合は「オマケ冊子に書かれた謎が解けない」の内容をご覧ください。"
        ),
      ]),

      p.foldable(
        "何が変わったのかはわかったが、その上でどうやってロゼを勝たせるのかがわからない",
        [
          p.text(
            "ロゼを勝たせるには、ウィンに「ん」で終わる言葉を答えさせる必要があります。"
          ),
          p.text(
            "しかし、ウィンの解答手番で表示される謎の答え、つまりウィンが答えられる言葉の中には「ん」で終わる言葉はありません。"
          ),
          p.showMore("もっと見る", "閉じる"),
          p.text("答えが「ん」で終わるのは、Kの謎とLの謎だけです。"),
          p.text(
            "どうにかしてどちらかの答えをウィンに答えさせることはできないでしょうか。"
          ),
          p.showMore("もっと見る", "閉じる"),
          p.text(
            "ウィンが答えられる謎の答えは、「せみぷろ」と「せぴあいろ」、「いのしし」と「いでんし」のように、同じ文字で始まる言葉は同じ文字で終わるようになっています。"
          ),
          p.text(
            "つまり、どの謎に答えたとしてもロゼに回す文字、そしてウィンに回ってくる文字は変わりません。"
          ),
          p.text("これではウィンにKの謎やLの謎を答えさせることはできません。"),
          p.text("この状況を打開する方法を探してみましょう。"),
          p.showMore("もっと見る", "閉じる"),
          p.text(
            "ここまでの勝負の結果が変わったことで、『五十音クイズバトル』や『レンタル野球』のアイコンの謎の答えが変わっていました。"
          ),
          p.text(
            "同じように、他の謎の中に答えが変わる謎があれば、しりとりに変化を起こすことができるかもしれません。"
          ),
          p.showMore("もっと見る", "閉じる"),
          p.text(
            "1回目よりもしりとりが長く続いたことで、その時は見られなかった日記の内容が見られるようになっています。"
          ),
          p.text("その中に重要な情報があります。"),
          p.showMore("もっと見る", "閉じる"),
          p.text(
            "重要な情報があるのは、ウィンの「毎日努力してるなんて」から始まる日記です。"
          ),
          p.text("ここで「明日はロゼの誕生日」と書かれています。"),
          p.text("ロゼの誕生日は何月何日だったでしょうか？"),
          p.showMore("もっと見る", "閉じる"),
          p.text(
            "箱を開けて最初に入っていた紙のキャラ紹介を見ると、ロゼの誕生日は3月27日と書いてあります。"
          ),
          p.text(
            "つまり、ロゼが「ありがとうウィン。」から始まる日記を書いた日は3月27日となります。"
          ),
          p.text(
            "この時点で3月27日であるならば、もう少し日付が経過すると4月になります。"
          ),
          p.showMore("もっと見る", "閉じる"),
          p.text(
            "4月になると、ウィンとロゼの何かが変化し、それによっていずれかの謎の答えが変わります。"
          ),
          p.showMore("もっと見る", "閉じる"),
          p.text("変わるものは、ズバリ「学年」です。"),
          p.text(
            "3月時点で2人は小学6年生でしたが、4月になると中学1年生になります。"
          ),
          p.text(
            "2人が中学1年生になったと考えてAの謎をもう一度解いてみましょう。"
          ),
          p.showMore("もっと見る", "閉じる"),
          p.text("その時、Aの謎の答えは『せんい』になります。"),
          p.text(
            "日付を整理して、4月になったときに『せんい』と答えてみましょう。"
          ),
          p.showMore("答えを見る", "閉じる"),
          p.text(
            "ウィンが「今日は新しいくつを買ったぜ！」から始まる日記を書くタイミングで『せんい』と答えましょう。"
          ),
          p.text("すると、次のウィンの手番で「し」の文字が回ってきます。"),
          p.text("そこでLの謎の答え、『しもん』と答えましょう。"),
        ]
      ),
    ]),

    p.foldable("1つ1つの謎が解けない", [
      p.text(
        "A～Hの謎のヒントはウィンが勝利するときのヒントに書かれているので、そちらをご覧ください。"
      ),
      p.foldable("Iの謎", [
        p.text("「ムラサキイロ」と「キイロ」に線が引かれています。"),
        p.text("それぞれ英語にしてみましょう。"),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『ろーぷうぇい』です。"),
      ]),

      p.foldable("Jの謎", [
        p.text("もともとは同じ大きさの正方形が並んだ形になっていました。"),
        p.text("そのような形に戻すために足りない線を考えてみましょう。"),
        p.text("足りない線を見ると2文字の漢字になります。"),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『しゅっせ』です。"),
      ]),

      p.foldable("Kの謎", [
        p.text("ロウソクのイラストが並んでいます。"),
        p.text("ロウソクを5文字の言葉で言い換えてみましょう。"),
        p.showMore("もっと見る", "閉じる"),
        p.text("ロウソクはキャンドルという言い方もできます。"),
        p.text(
          "左の4つのロウソクに「ロウソク」、右の5つのロウソクに「キャンドル」と当てはめ、炎の大きさに気を付けて答えを導きましょう。"
        ),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『ろんどん』です。"),
      ]),

      p.foldable("Lの謎", [
        p.text(
          "左に並んだ図形は、共通のある図形から一部の線が消えた図形になっています。"
        ),
        p.showMore("もっと見る", "閉じる"),
        p.text("共通のある図形とは「田」のような図形です。"),
        p.text("消えている線をカタカナとして読んでみましょう。"),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『しもん』です。"),
      ]),

      p.foldable("五十音クイズバトルのアイコンの謎", [
        p.text(
          "ウィンが負けたときは、ウィンは「あめだま」をもらっていました。"
        ),
        p.text(
          "「あ」「め」「だ」「ま」の文字を黄色くし、ルールにそってSからGまで進みましょう。"
        ),
        p.showMore("もっと見る", "閉じる"),
        p.text("紙面上で、右、下、左、下、右と進むとGのマスにたどり着きます。"),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『ろんがい』です。"),
      ]),

      p.foldable("レンタル野球のアイコンの謎", [
        p.text(
          "ウィンが白旗を振った時点で勝負が終わったため、『レンタル野球』の勝負でロゼが最後に投げたものは、白いボールになります。"
        ),
        p.text(
          "白いボールの指示、「薄い文字、上から」に従って文字を探して読みましょう。"
        ),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『ろっかくけい』です。"),
      ]),

      p.foldable("学校すごろくのアイコンの謎", [
        p.text(
          "ウィンが負けた時、ウィンが最後にいた場所はふりだしのマス、一番左にある桜が写りこんだ赤いマスになります。"
        ),
        p.showMore("もっと見る", "閉じる"),
        p.text(
          "3番目に通った場所と2番目に通った場所は変わらず、一番右の画像に写ったマスと一番下の画像に写ったマスです。"
        ),
        p.text(
          "3つの画像の中心を線で結び、できた三角形の中にある文字をならびかえましょう。"
        ),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『しあわせ』です。"),
      ]),

      p.foldable("カルテットストライカーズのアイコンの謎", [
        p.text(
          "『カルテットストライカーズ』で使用したカードを見て、カードの攻撃力で計算をしましょう。"
        ),
        p.text(
          "レッドヘビーロードの攻撃力は6、パープルロータスの攻撃力は9、足すと15になります。"
        ),
        p.text(
          "下にある表を見ると、1は「ナ」、5は「ゾ」に対応しており、15は「ナゾ」になることがわかります。"
        ),
        p.text("同じように下の式も計算しましょう。"),
        p.showMore("もっと見る", "閉じる"),
        p.text(
          "ウィンが負けた時、「勝ち残ったカード」はロゼが4枚目に使ったブルードラゴンで、攻撃力は50です。"
        ),
        p.text(
          "また、パープルジェントルの攻撃力は7、グリーンゴーレムの攻撃力は4です。"
        ),
        p.text("これらの数字を式に当てはめると「50×7-4」となります。"),
        p.showMore("もっと見る", "閉じる"),
        p.text("計算すると、346になります。"),
        p.text("表を使って、数字から文字に変換しましょう。"),
        p.showMore("答えを見る", "閉じる"),
        p.text("答えは『しらせ』です。"),
      ]),
    ]),

    p.text(" "),
    p.text(" "),
    p.foldable("すべての勝負に勝利した人はこちら", [
      p.text(
        "ここから先は重大なネタバレが含まれます。\nすべての勝負に勝利していない方は絶対に見ないでください。"
      ),
      p.foldable("ウィンが勝利した先のヒントを見る", [
        p.text(
          "ここから先は、ロゼを勝たせる方法を探している方向けの内容です。"
        ),
        p.text(
          "すべての勝負でロゼが勝利する方法を探している場合は、第一勝負『五十音クイズ』から順番に攻略することを強くオススメします。"
        ),
        p.text(
          "また、「？」の封筒を開いていない方は、封筒を開いて中身を確認してから考えてみましょう。"
        ),
        p.foldable("ロゼを勝たせる方法のヒントが見たい", [
          p.text(
            "ロゼを勝たせる方法のヒントがほしい方は各勝負のヒントキーワードの先頭に「ロゼ」をつけて入力してください。"
          ),
        ]),

        p.foldable(
          "ロゼを勝たせることはできたがメッセージが出てきて先に進めない",
          [
            p.text(
              "ロゼが勝ちそうになると「このままではウィンが負けてしまいます。」というメッセージが表示されます。"
            ),
            p.text(
              "メッセージ内の「ウィン」の文字を10回タッチすることでメッセージを消して先に進むことができます。"
            ),
          ]
        ),
      ]),
    ]),
  ]
);

export const allHints: AllHintStepData = {
  step1: stepData1,
  step2: stepData2,
  step3: stepData3,
  step4: stepData4,
  step5: stepData5,
  step6: stepData6,
  step7: stepData7,
  step8: stepData8,
  step9: stepData9,
  step10: stepData10,
};

export const hintSiteConfig: HintSiteConfig = {
  steps: allHints,
  reactions: [],
};
